<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 商品初始化表单 -->
      <init-form ref="initForm" @ok="handleOk" @cancel="handleCancel"/>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import InitForm from './modules/InitForm'

export default {
  name: 'GoodsInit',
  components: {
    InitForm
  },
  data() {
    return {}
  },
  methods: {
    handleOk(data) {
      this.$message.success('商品初始化成功')
      // 延迟返回列表，让用户看到成功提示
      setTimeout(() => {
        // 返回列表页并添加刷新标记
        this.$router.push({
          path: '/goods/goods',
          query: {
            t: new Date().getTime()
          }
        })
      }, 1000)
    },
    handleCancel() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
</style>
